exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueCarousel[data-v-0be7b6d1]{max-width:150px}.column-blanco[data-v-0be7b6d1]{padding-bottom:50px}.image.is-150x150[data-v-0be7b6d1]{height:150px;widows:150}.table-responsive[data-v-0be7b6d1]{overflow-x:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0be7b6d1","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/resumen_Componentes/HomeResumen.vue
// module id = 2864
// module chunks = 0